import React,{useState} from 'react'
import { Dialog, DialogActions, DialogContent,  IconButton, Tooltip } from "@mui/material";
import { Delete, Warning } from '@mui/icons-material';
import authServices from '../auth/authServices';
import { useSelector } from 'react-redux';


export default function ConfirmDialog({id, confirm,children}) {
    const [dialogStatus, setDialogStatus] = useState(false);
    const handleClose = () =>{
        setDialogStatus(false)
    }

    /* Pin Work*/
    const authUser = useSelector((state) => state.auth); 
    const userId=  authUser.id;
    const [pin,setPin] = useState("");
    const verifyPin = () =>{
        authServices.verifyPin({pin:pin,userId:userId}).then(res=>{
            confirm(id);
            handleClose();
        }).catch(error=>{
            alert("Invalid Pin");
        })
    }
    /* Pin dialog  end*/
    return (
    <>  
        
        <Tooltip title="Remove">
            <IconButton onClick={()=>setDialogStatus(true)} style={{padding:"0px"}}>
                <Delete/>
            </IconButton>
        </Tooltip>
        
        <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
        >

            <DialogContent> <Warning/> {children}</DialogContent>
            <DialogActions>
                <input placeholder="Enter your pin" type="password" className="form-cotrol" value={pin} onChange={(e)=>{setPin(e.target.value)}} ></input>
                <button type="button" onClick={verifyPin} className="btn btn-danger">Yes</button>
                <button type="button" onClick={handleClose} className="btn btn-success">No</button>
            </DialogActions>
        </Dialog>
    </>
    )
}
